var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-wrapper loader-container current-verions"},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":[_vm.currentVersions]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }